<script>
    import TextInput from './TextInput.svelte';

    /** @type {string} */
    export let id = 'rnd' + Math.random().toString(36).substring(7);

    /** @type {string} */
    export let label;

    /** @type {'text'|'email'|'password'|'url'|'tel'|'area'|'number'} */
    export let type = 'text';

    /** @type {boolean} */
    export let required = false;

    /** @type {string} */
    export let placeholder;

    /** @type {boolean} */
    export let disabled = false;

    /** @type {string} */
    export let value = null;

    /** @type {string} */
    export let hint = null;

    /** @type {boolean} */
    export let hasError = false;

    /** @type {string} */
    export let errorMessage = undefined;

    /** @type {undefined|'small'|'medium'|'large'} */
    export let height = null;

    /** @type {string} */
    export let step = 'any';

    /** @type {number} */
    export let min = undefined;

    /** @type {number} */
    export let max = undefined;

    /** @type {number} */
    export let minlength = 1;

    /** @type {number} */
    export let maxlength = 99;

    /** @type {boolean} */
    export let labelHidden = false;

    /** @type {string} */
    export let autocomplete = 'off';

    /** @type {boolean|undefined} */
    export let spellcheck = undefined;

    /** @type {number} */
    export let cols = 20;

    /** @type {number} */
    export let rows = 2;

    /** @type {'left' | 'top'} */
    export let labelPosition = 'top';

    /** @type {undefined | 'off' | 'polite' | 'assertive'} */
    export let ariaLiveUpdateType = null;

    $: areaSizeClass =
        type === 'area' && height
            ? 'prom-input-field--' + height + '-area'
            : '';

    $: hasErrorClass = hasError ? 'prom-input-field--has-error' : '';

    $: labelText =
        !label || typeof label !== 'string'
            ? console.warn('Label must be supplied')
            : label;

    $: errorMessageId = id + '__error-message';

    $: labelHiddenClass = labelHidden ? 'screen-reader' : '';
</script>

<div id="{id}" class="prom-input-field {hasErrorClass}">
    <!-- Ignore this a11y warning because it is incorrect, the label contains the control -->
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label class:prom-input-field--label-left={labelPosition === 'left'}>
        <span class="prom-input-field__label {labelHiddenClass}">
            {labelText}
            {#if required}
                <span aria-hidden="true" class="prom-input__required-star"
                    >*</span>
            {/if}
            {#if hint}<span class="prom-input-field__hint">{hint}</span>{/if}
        </span>

        <TextInput
            type="{type}"
            id="prom-input-{id}"
            classText="prom-input-field__input {areaSizeClass}"
            disabled="{disabled}"
            placeholder="{placeholder}"
            required="{required}"
            {hasError}
            spellcheck="{spellcheck}"
            autocomplete="{autocomplete}"
            describedby="{errorMessageId}"
            cols="{cols}"
            rows="{rows}"
            step="{step}"
            min="{min}"
            max="{max}"
            minlength="{minlength}"
            maxlength="{maxlength}"
            bind:value
            on:focus
            on:blur
            on:click
            on:keyup />
    </label>

    <div
        aria-live={ariaLiveUpdateType}
        class="prom-error-message"
        class:prom-error-message--shown={hasError && errorMessage}
        id="{errorMessageId}">
        {#if hasError && errorMessage}
            {errorMessage}
        {/if}
    </div>
</div>
